import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      Senerare mi povus diri, ke ŝi estas altranga persono. 
      Sed ŝi ne portas kolorajn jupojn kaj arĝentan kronon, ŝi ne dancis surplace dum granda popolfesto, 
      kiu ĵus okazis, kaj ne akompanis la trupojn, kiujn ni adiaŭis por glora marŝo al ribelinta subula lando. 
      Ŝi ĉiam sola trairadas la urbon, kaj eskorto de du soldatoj akompanas ŝin demalproksime, 
      laŭ la prudenta kutimo en nia malfermita al la tuta mondo urbo. 
    </p>
    
    <p class="mb-3">
      Kio ŝi estas?
    </p>
    
    <p class="mb-3">
      Kiu ŝi estas?
    </p>
    
    <p class="mb-3">
      Unuan fojon mi ekvidis ŝin, kiam ŝi aperis sur la ĉefa strato de nia urbo. 
      Sola, en obskura robo si preteriris la tumulton, kiu ĉiam vagaĉis en tiu loko: buntan svarmon de vendistoj, 
      negociistoj, maristoj kaj spionoj. 
      Ŝi iris preter ili, kaj videblis, kiel diafana veziko ĉirkaŭis ŝin, ŝirmante kontraŭ ruĝaj, nigraj, violaj, 
      oranĝkoloraj puŝoj, atakoj kaj lascivaj atencoj. 
      Kiom fajna estis tiu travidebla ujo! Kiel ĝi fleksiĝadis dum interpuŝado, 
      jen konkave ĝis preskaŭ neekzistanta dikeco, jen disblove, preskaŭ kreviĝonte. 
      Nur tavolo da kelkaj mikronoj disigis ŝin de plenforta aroganta homamaso. 
      Mi rimarkis, kiom maldika ĝi estas…
    </p>
    
    <p class="mb-3">
      Mi postsekvis ŝin ĝis la domo, kien ŝi venis…
    </p>
    
    <p class="mb-3">
      En la domo oni diris, ke la vidvino el nordaj provincoj vizitis nin por kelka tempo. 
      Ŝi luis tie ĉambrojn, sed plian informon oni ne donis.
    </p>
    
    <p class="mb-3">
      Mi revenis hejmen ravigita. 
      Ekde nun mi ĉie renkontos kaj akompanos ŝin; ŝi ne povos ne rimarki min, mi devas alproksimiĝi al ŝi, 
      ĉar sen ŝi mia vivo ne plu eblas. 
      Ekde nun la sola mia revo kaj deziro estas ligitaj kun ŝi. 
    </p>
    
    <p class="mb-3">
      Sekvatage mi renkontis ŝin ĉe la rivero. 
      Ŝi estis sola. La du soldatoj ne intermiksiĝis en nian konversacion. 
      Sed fiŝkaptistoj surborde grumblis, kaj ni foriris al pli konvena loko, kie forestis arbustoj, 
      fiŝoj kaj homoj. 
      Mi, kapitano de la Ruĝĉapela Reĝa milittaĉmento, min prezentis al ŝi, 
      afable petante permeson akompani ŝin hejmen el tiu nerekomendinda dezerta loko. 
      Ŝi neatente rigardis min kaj respondis, ke ŝi ĉiam ŝatis promeni surnature sola kaj ne bezonas akomponantojn nek tien, 
      nek reen, nek surloke. 
      Ŝi eldiris tion tute ne ofende, trankvile, sed mi ne plu povis resti apude. 
      Io neatendeble firma estis en ŝia voĉo kaj sinteno; io, kio malgraŭ ŝajne videbla ŝia malforteco kaj angora soleco, 
      akre frapis min. 
      Oni ne povas tiel facile komunikigi ŝin. 
      Mirigita mi foriris.
    </p>
    
    <p class="mb-3">
      Tamen tio ne haltis min.Tage kaj nokte mi pensis pri ŝi. 
      Mi konatiĝis kun ŝiaj dommastroj kaj sub la preteksto de civitana milita devo lokigis tie patrolon de miaj soldatoj, 
      kiujn mi ĉiuvespere vizitadis por ricevi tagraporton, kaj poste teumi kun la mastroj. 
      Ŝi dekomence dividis niajn vesperojn, sed poste komencis eviti ilin; kaj surstrate mi ne arogis alparoli ŝin.
    </p>
    
    <p class="mb-3">
      Ŝi vere evidentiĝis vidvino el norda nobela, sed malriĉiĝinta familio. 
      Ŝia edzo estis ege pli aĝa ol ŝi; oni edzinigis ŝin pro lia mono, kaj li tentiĝis je ŝia beleco, 
      sed pro vivoŝanĝoj kaj maltrankviliĝoj de la nova vivo lia sano sinkis kaj li mortis post duonjaro da geedzeco. 
      La filoj de lia unua edzino ekprocesis pro la heredo, kaj rezulte ŝi ricevis nur tiom el lia vere granda posedaĵo, 
      ke apenaŭ ŝi povis vivteni sin je tre modera nivelo. 
    </p>
    
    <p class="mb-3">
      Ĝuste tial ŝi forveturis el sia naskourbo, kie ĉiu memoris ŝin komence  kiel juna belulino; luksa, 
      tamen ne tro feliĉa nobelino; kaj poste – trompita kaj kalumniita, denove malriĉa, sed jam ne juna virino. 
      Ŝi forveturis al nia libera urbo, la haveno malfermita por ĉiuj mondopartoj. 
      Eble, ŝi planis poste elnavigi al iu fora lando… 
      Kaj tiuj du soldatoj estis nur kutima en nia urbo Gvardio de la Duko, 
      kiu akompanas ĉiujn fremdlandajn virinojn, se ili estis noblaj kaj solaj. 
      Tio estas ja necesa en nia senzorga kaj senleĝa urbo. La Duko lasas la enajn aferojn iri kiel ili iras; 
      sed li severe zorgas pri sia ekstera reputacio kaj neniam permesas, 
      ke iu okazintaĵo makuligu la gasteman kaj ĉiam servopretan imagon de la urbo. 
    </p>
    
    <p class="mb-3">
      Do, ŝi vere estis tute sola, kaj neniu pretendis ŝin.
    </p>
    
    <p class="mb-3">
      Neniu, krom mi, kiu post la unua rigardo eksentis, ke niaj vojoj devas kunfliu kaj niaj vivoj kuniĝi. 
      Mi bezonis neniun krom ŝi en la tuta mondo, kaj mi sciis, sciis severe kaj firme, 
      ke mia deziro plenumiĝos kaj ŝi cedos al mi.
    </p>
    
    <p class="mb-3">
      Post du monatoj ŝi ne plu rifuzis mian akompanon dum la promenadoj; ni babilis indiferente kaj ĝentile. 
      Kaj mi paŝ-post-paŝo konkeradis ŝian koron. 
      Ja la mia jam delonge apartenis al ŝi!
    </p>
    
    <p class="mb-3">
      En la tago, kiam ŝi la unuan fojon permesis preni sian manon, mi trovis, reveninte hejmen, 
      la ordonon de la Duko: mi devis tuj gvidi la taĉmenton, konkerontan la ribelan insulon, 
      kie tute neatendite ekflamis konspiro. 
    </p>
    
    <p class="mb-3">
      Mi forveturis matene, sendinte kurtan poŝtkarton al ŝi, kie mi diris nur, ke mia milita devo vokas min; 
      sed post mia honoro, la plej valora en la mondo por mi estas ŝi, kaj ni ne disiĝos porlonge.
    </p>
    
    <p class="mb-3">
      En la unua batalo hazarda kuglo trafis min je kolo, kaj dum du monatoj mi kuŝaĉis en hospitalo. 
      La gazetoj disblovis pri mia heroa konduto kaj poste pri mia dekorigo de la ordeno "Blanka Rubando". 
      Ŝi venis al mia hospitalo dum mi estis ankoraŭ senkonscia. 
      Kiam mi malfermis la okulojn, mi ekvidis ŝin. 
      Ŝi etendis al mi manojn por viŝi mian frunton. 
      Kiam ŝiaj manoj tuŝis min, mi svenis denove. 
    </p>
    
    <p class="mb-3">
      Ni geedziĝis kiam mi ekpovis forlasi la liton. Kiam mi brakumis ŝin, mi ne plu eksentis la reziston. 
      Tiu transparenta ujo ĉirkaŭ ŝi ne plu ekzistis. 
      Ŝi formetis ĝin, ŝi donis sin al mi senrezerve. 
      Absolute nenio jam staris inter ni, nenio protektis ŝin kontraŭ fremda volo. 
      Ŝi plene apartenis al mi. 
      Mi atendis tiun momenton delonge, ho, kiel delonge!
    </p>
    
    <p class="mb-3">
      Ĉiuj homoj estas protektitaj, ĉiuj kovritaj per diafana nepenetrebla ŝelo. 
      Sed ŝia ŝelo aperis por mi vundebla kaj penetrebla; 
      kaj mi ĉasis kaj persekutis ŝin ĝis kiam ŝi iĝis senhelpa kaj mia. 
      Ŝi ekzistis por esti ies predo; se ne mi, do iu alia konkerus ŝin, ĉar estis ja videble, 
      ke ŝi ne povas protekti sin, ne povas kontraŭstari al forta volo, forta deziro. 
      Ŝi estis destinita por fali al ies manoj. 
    </p>
    
    <p class="mb-3">
      Ŝi falis al la miaj. 
      Kial do ne? 
      Mi longe atendis kaj fin-fine mi akiris ŝin. 
      Mi volas vivi kun ŝi longe.
    </p>

    <p class="text-center bold mb-3">* * *</p>
    
    <p class="mb-3">
      Ili vivis kune dum ok jaroj. 
      Ŝi ne plu promenis sola; kaj entute ŝi ne plu promenis. 
      Ŝi ĉiam akompanis sian edzon aŭ sidis hejme atendante lin. 
      Ŝi ne havis aliajn strebojn, pensojn, dezirojn krom tiujn de la edzo. 
      Neniu plu rimarkis ŝin aŭ ŝian transparentan aŭreolon. 
    </p>
    
    <p class="mb-3">
      Post ok jaroj ŝi silente kaj neatentinde mortis. 
    </p>
    
    <p class="mb-3">
      Li vivis ankoraŭ 15 jarojn post ŝi.
    </p>
    
    <p class="mb-3">
      Li havis jam sufiĉe da vivoforto. 
    </p>



    `
  )
}

const itemName = {
  esp: 'Ankoraŭ unu historio pri amo'
}

const date = {
  esp: '1993'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp,
    itemDate: date.esp
  }
}

export default item; 